import React, { useState } from 'react';
import styled from 'styled-components';
import { ThreeDots } from 'src/components/CommonMenu/comps';
import CommonMenu from 'src/components/CommonMenu';

const Div = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 8px;
  margin-right: 6px;
  min-width: 22px;
  padding-left: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

interface GTTdmProps {
  onViewClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onAddToRMPClick?: () => void;
  onMakeAdminClick?: () => void;
  onRemoveUserClick?: () => void;
  onCancelInviteClick?: () => void;
  onAcceptRequestClick?: () => void;
  onRejectRequestClick?: () => void;
  onUnlinkScenarioClick?: () => void;
  onUnlinkIncidentClick?: () => void;
  onCopyClick?: () => void;
  onUnlickControl?: () => void;
  onInviteClick?: () => void;
  onGrantAccessClick?: () => void;
  onAddStrategyClick?: () => void;
  onAddControlClick?: () => void;
  onAddIncidentClick?: () => void;
  onLinkScenarioClick?: () => void;
  onMarkAsCompletedClick?: () => void;
  onChangePermissions?: () => void;
  onAddActionClick?: () => void;
  extraComponentLeft?: React.ReactNode;
}

export const GTTdm: React.FC<GTTdmProps> = ({
  onViewClick,
  onEditClick,
  onDeleteClick,
  onAddToRMPClick,
  onMakeAdminClick,
  onRemoveUserClick,
  onCancelInviteClick,
  onAcceptRequestClick,
  onRejectRequestClick,
  onCopyClick,
  onUnlinkScenarioClick,
  onUnlickControl,
  onUnlinkIncidentClick,
  extraComponentLeft,
  onInviteClick,
  onGrantAccessClick,
  onAddStrategyClick,
  onAddControlClick,
  onAddIncidentClick,
  onLinkScenarioClick,
  onMarkAsCompletedClick,
  onChangePermissions,
  onAddActionClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | SVGElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e: React.MouseEvent<SVGElement>) => {
    setAnchorEl(e.currentTarget);
    e.stopPropagation();
  };

  const onMenuClick = (e: React.MouseEvent<HTMLLIElement>, cb?: () => void) => {
    e.stopPropagation();
    if (!cb) return;
    handleClose();
    cb();
  };

  const containsMenu =
    onViewClick ||
    onEditClick ||
    onDeleteClick ||
    onAddToRMPClick ||
    onMakeAdminClick ||
    onCancelInviteClick ||
    onAcceptRequestClick ||
    onRejectRequestClick ||
    onCopyClick ||
    onUnlinkScenarioClick ||
    onUnlickControl ||
    onRemoveUserClick ||
    onUnlinkIncidentClick ||
    onInviteClick ||
    onGrantAccessClick ||
    onAddStrategyClick ||
    onAddControlClick ||
    onAddIncidentClick ||
    onLinkScenarioClick ||
    onMarkAsCompletedClick ||
    onChangePermissions ||
    onAddActionClick;

  return (
    <Div onClick={(e) => e.stopPropagation()} className="ThreeDots__Wraper">
      {extraComponentLeft}
      {!!containsMenu && (
        <>
          <ThreeDots onClick={handleClick} dataCy="table-dots-menu" alwaysActiveColor />
          <CommonMenu
            onViewClick={onViewClick ? (e) => onMenuClick(e, onViewClick) : undefined}
            onEditClick={onEditClick ? (e) => onMenuClick(e, onEditClick) : undefined}
            onDeleteClick={onDeleteClick ? (e) => onMenuClick(e, onDeleteClick) : undefined}
            onAddToRMPClick={onAddToRMPClick ? (e) => onMenuClick(e, onAddToRMPClick) : undefined}
            onMakeAdminClick={onMakeAdminClick ? (e) => onMenuClick(e, onMakeAdminClick) : undefined}
            onRemoveUserClick={onRemoveUserClick ? (e) => onMenuClick(e, onRemoveUserClick) : undefined}
            onCancelInviteClick={onCancelInviteClick ? (e) => onMenuClick(e, onCancelInviteClick) : undefined}
            onAcceptRequestClick={onAcceptRequestClick ? (e) => onMenuClick(e, onAcceptRequestClick) : undefined}
            onRejectRequestClick={onRejectRequestClick ? (e) => onMenuClick(e, onRejectRequestClick) : undefined}
            onCopyClick={onCopyClick ? (e) => onMenuClick(e, onCopyClick) : undefined}
            onUnlinkScenarioClick={onUnlinkScenarioClick ? (e) => onMenuClick(e, onUnlinkScenarioClick) : undefined}
            onUnlickControl={onUnlickControl ? (e) => onMenuClick(e, onUnlickControl) : undefined}
            onUnlinkIncidentClick={onUnlinkIncidentClick ? (e) => onMenuClick(e, onUnlinkIncidentClick) : undefined}
            onInviteClick={onInviteClick ? (e) => onMenuClick(e, onInviteClick) : undefined}
            onGrantAccessClick={onGrantAccessClick ? (e) => onMenuClick(e, onGrantAccessClick) : undefined}
            onAddStrategyClick={onAddStrategyClick ? (e) => onMenuClick(e, onAddStrategyClick) : undefined}
            onAddControlClick={onAddControlClick ? (e) => onMenuClick(e, onAddControlClick) : undefined}
            onAddIncidentClick={onAddIncidentClick ? (e) => onMenuClick(e, onAddIncidentClick) : undefined}
            onLinkScenarioClick={onLinkScenarioClick ? (e) => onMenuClick(e, onLinkScenarioClick) : undefined}
            onMarkAsCompletedClick={onMarkAsCompletedClick ? (e) => onMenuClick(e, onMarkAsCompletedClick) : undefined}
            onChangePermissions={onChangePermissions ? (e) => onMenuClick(e, onChangePermissions) : undefined}
            onAddActionClick={onAddActionClick ? (e) => onMenuClick(e, onAddActionClick) : undefined}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          />
        </>
      )}
    </Div>
  );
};
